import React from "react";
import Icon from "../../../components/AppIcon";

/**
 * ContactFormSection
 * Visual wrapper that matches the apartment/room detail form card.
 */
const ContactFormSection = ({
  title = "Contact about this property",
  subtitle = "Send a message about availability, pricing, or any questions.",
  iconName = "MessageCircle",
  children,
  className = "",
  headerRight = null,
}) => {
  return (
    <section
      className={`bg-card rounded-xl border shadow-subtle p-6 md:p-8 ${className}`}
    >
      {/* Header */}
      <div className="flex items-start justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
            <Icon name={iconName} size={18} className="text-primary" />
          </div>
          <div>
            <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground">
              {title}
            </h2>
            {subtitle && (
              <p className="text-sm text-muted-foreground mt-0.5">{subtitle}</p>
            )}
          </div>
        </div>
        {headerRight ? <div>{headerRight}</div> : null}
      </div>

      {/* Content */}
      <div className="mt-2">{children}</div>
    </section>
  );
};

export default ContactFormSection;
